import React, { useContext } from 'react';
import { OfferContext, getLabelValue } from '@adac-mp/shared';
import { Button } from '../../index';
import { useViewport } from '../../hooks/useViewport';

interface IFooterButtonNav {
	stepTitle: string;
	reuse?: boolean;
	step: number;
	lastStep: number;
	validated: boolean;
	onClick: () => void;
	onReuseClick: () => void;
	['data-cy']?: string;
}

export const FooterButtonNav = ({
	stepTitle,
	reuse,
	step,
	lastStep,
	validated,
	onClick,
	onReuseClick,
	'data-cy': dataCy = '',
}: IFooterButtonNav) => {
	const { viewport } = useViewport();
	const { labels } = useContext(OfferContext);
	const isDesktop = viewport === 'desktop';

	const buttonLabel =
		step === lastStep
			? getLabelValue('mp.addToCart', labels) || 'Produktauswahl abschließen'
			: getLabelValue('mp.nextButton', labels) || 'Weiter';

	return (
		<div className={`sticky bottom-0 md:relative ${!isDesktop && 'z-50'}`}>
			<div className="bg-white p-1.5 flex flex-col gap-1.5 md:flex-row md:gap-4 md:justify-center md:items-center md:pt-6 md:pb-[96px] md:h-auto md:bg-transparent md:max-w-desktop md:mx-auto">
				{reuse && step === 0 && (
					<Button
						fullWidth
						variant="secondary"
						className="md:w-3/12"
						tracking={{
							funnel_click: {
								label: getLabelValue('mp.reuseButton', labels) || 'Anderes Fahrzeug auswählen',
								element: stepTitle,
							},
						}}
						onClick={onReuseClick}>
						{getLabelValue('mp.reuseButton', labels) || 'Anderes Fahrzeug auswählen'}
					</Button>
				)}
				<Button
					fullWidth
					data-cy={dataCy}
					size="md"
					className="md:w-3/12 mb-0"
					tracking={
						stepTitle && validated
							? {
									funnel_click: {
										label: step === lastStep ? 'Produktauswahl abschließen' : 'Weiter',
										element: stepTitle,
									},
							  }
							: {}
					}
					onClick={onClick}>
					{buttonLabel}
				</Button>
			</div>
		</div>
	);
};
